import { AppSettingsConfig, RowsPerPage, RowsPerPageTarget } from 'core/service/user-preferences/domain';
import { UserCustomFilter } from 'core/utils/types/user-custom-filter.type';
import { UserPreferencesViewConfig } from 'modules/global/model';
import { OperatorsFilterFields } from 'modules/operators/types/operators-filter.type';
import { DEFAULT_LANGUAGE } from 'core/constants/constants';
import React, { createContext } from 'react';
import { DEFAULT_PAGINATION_SIZES_BY_TARGET } from './hooks/use-user-page-sizer-manager.hook';

export type UserPreferencesContextType = {
    userLanguage: string;
    userPreferencesViewConfig: UserPreferencesViewConfig;
    sideMenuEntries: UserCustomFilter<OperatorsFilterFields>[];
    pageSize: RowsPerPage;
    userPreferencesId?: string;
    operatorReportHeaderValue?: string;
    isLoading: boolean;
    isPaginationLoading: boolean;
    appSettings: AppSettingsConfig;
    updateUserLanguage: (language: string) => void;
    updatePageSize: (newPageSize: number, target: RowsPerPageTarget) => void;
    setSideMenuEntries: React.Dispatch<React.SetStateAction<UserCustomFilter<OperatorsFilterFields>[]>>;
    setUserPreferencesViewConfig: React.Dispatch<React.SetStateAction<UserPreferencesViewConfig | undefined>>;
    setOperatorReportHeaderValue: React.Dispatch<React.SetStateAction<string>>;
    refreshUserPreferences: VoidFunction;
    setAppSettings: React.Dispatch<React.SetStateAction<AppSettingsConfig>>;
};

export const UserPreferencesContext = createContext<UserPreferencesContextType>({
    userLanguage: DEFAULT_LANGUAGE,
    userPreferencesViewConfig: {} as UserPreferencesViewConfig,
    sideMenuEntries: [],
    pageSize: DEFAULT_PAGINATION_SIZES_BY_TARGET,
    userPreferencesId: undefined,
    operatorReportHeaderValue: '',
    isLoading: false,
    isPaginationLoading: false,
    appSettings: {} as AppSettingsConfig,
    updateUserLanguage: () => {},
    setSideMenuEntries: () => {},
    setUserPreferencesViewConfig: () => {},
    setOperatorReportHeaderValue: () => {},
    refreshUserPreferences: () => {},
    updatePageSize: (_newPageSize: number, _target: RowsPerPageTarget) => {},
    setAppSettings: () => {},
});
